import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import { useCallback, useEffect, useMemo, useState } from "react";
import { numberFormatter } from "../../utils/generalFunctions";
import UpdateGenericWorkflowDialog from "../Workflow/UpdateGenericWorkflowDialog";
import { selectStyleObj } from "./WriteOff";
import {
  getAging,
  useAllocationIssues,
  useCorrectionTypes,
  useUserData,
  getTodaysDateInLocalTimezone
} from "./hooks";
import { customDateFormat, listToMap, startOfDay } from "./utils";
import { toast, ToastContainer } from "react-toastify";
const getAgeDays = (paymentReceiveDate, remainingBalance) => {
  if (remainingBalance <= 0 || !paymentReceiveDate) return 0;

  const diff =
    startOfDay(new Date()).getTime() -
    startOfDay(new Date(paymentReceiveDate)).getTime();

  const daysDiff = Math.floor(diff / 86400000);

  return daysDiff;
};

const History = ({ history, useIdMap, correctionTypeIdMap, fixedDetails }) => {
  const [
    openUpdateGenericCorrectionTypeWorkflowDialog,
    setOpenUpdateGenericCorrectionTypeWorkflowDialog,
  ] = useState(false);
  const [currentWorkflowName, setCurrentWorkflowName] = useState("");
  const [currentTxnWorkflowDetails, setCurrentTxnWorkflowDetails] = useState(
    {}
  );

  const handleUpdateGenericWorkflowDialog = () => {
    setOpenUpdateGenericCorrectionTypeWorkflowDialog(false);
  };
  return (
    <div className="cash-allocation-dialogue-container">
      <Grid container>
        {fixedDetails.map(({ label, value }, i) => (
          <Grid
            item
            xs={12}
            md={6}
            key={label}
            paddingLeft={i % 2 ? 2 : 0}
            paddingRight={i % 2 ? 0 : 2}
            marginBottom={2}
          >
            <span style={{ fontWeight: label === "Policy#" ? 800 : 400 }}>
              {label}
            </span>
            <span style={{ fontWeight: "bold" }}>: {value}</span>
          </Grid>
        ))}
      </Grid>
      <TableContainer sx={{ height: 275, overflow: "auto" }}>
        <Table>
          <TableHead className="table-head">
            <TableRow>
              <TableCell
                sx={{ fontSize: "15px", fontWeight: 800 }}
                className="table-cell"
              >
                Requested On
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Issue Category
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Correction Reason
              </TableCell>

              {/* <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Amt
              </TableCell> */}
              {/* <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                Ccy
              </TableCell> */}
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800 }}
              >
                WF Status
              </TableCell>
              <TableCell
                className="table-cell"
                sx={{ fontSize: "15px", fontWeight: 800, display: "flex", justifyContent: "center" }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {history.map((row, index) => (
              <TableRow key={index} className="table-row">
                <TableCell className="table-cell">
                  {customDateFormat(row?.issue_date)}
                </TableCell>
                <TableCell className="table-cell">
                  {row?.issue_category}
                </TableCell>
                <TableCell className="table-cell">
                  {correctionTypeIdMap[row?.correction_type] ?? ""}
                </TableCell>
                {/* <TableCell className="table-cell">{numberFormatter(row?.refund_amt ?? 0)}</TableCell> */}
                {/* <TableCell className="table-cell">{row?.currency}</TableCell> */}
                <TableCell className="table-cell">
                  {row?.workflow?.workflow_status}
                </TableCell>
                <TableCell className="table-cell" style={{ display: "flex", justifyContent: "flex-end" }}>
                  {row?.issue_category !== "Premium Payment" && (
                    <IconButton>
                      <SettingsTwoToneIcon
                        onClick={() => {
                          setCurrentWorkflowName(
                            row?.workflow?.workflow_json_data?.workflow_name ??
                            ""
                          );
                          setCurrentTxnWorkflowDetails(row?.workflow ?? {});
                          setOpenUpdateGenericCorrectionTypeWorkflowDialog(
                            true
                          );
                        }}
                        sx={{ fontSize: "25px", color: "#3b3f44" }}
                      />
                    </IconButton>
                  )}
                  <IconButton>
                    <FileDownloadOutlinedIcon
                      sx={{ fontSize: "25px", color: "blue" }}
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {openUpdateGenericCorrectionTypeWorkflowDialog && (
        <UpdateGenericWorkflowDialog
          openUpdateGenericWorkflowDialog={
            openUpdateGenericCorrectionTypeWorkflowDialog
          }
          handleUpdateGenericWorkflowDialog={handleUpdateGenericWorkflowDialog}
          workflowName={currentWorkflowName}
          currentWorkflowDetails={currentTxnWorkflowDetails}
        />
      )}
    </div>
  );
};

const CorrectionTypes = ({ allocation, handleClose, transaction, isAutoInitiation = false, isAuthorizedUser, viaHistoryLink = false }) => {
  const { history, formData, setFormData, submit, isApiInProgress, loadHistory } = useAllocationIssues(
    {
      allocation,
      transaction,
      isAutoInitiation
    }
  );
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const [showHistory, setShowHistory] = useState(false);
  const [isAutoInitiationCorrectionTypes, setIsAutoInitiationCorrectionTypes] = useState(isAutoInitiation)
  // const issueCategories = useIssueCategory();
  const correctionTypes = useCorrectionTypes(allocation?.allocation_status ?? "");
  const allCorrectionTypes = useCorrectionTypes("");
  const users = useUserData();
  const fixedDetails = useMemo(
    () => [
      {
        label: "System Date",
        value: customDateFormat(formData?.issue_date),
      },
      {
        label: "Txn Date",
        value: customDateFormat(allocation?.bank_txn?.Payment_Receive_Date),
      },
      {
        label: "System",
        value: allocation?.allocation_systemid,
      },
      {
        label: "Bank A/c#",
        value: allocation?.bank_txn?.bank_details?.account_number,
      },
      {
        label: "Status",
        value: allocation?.allocation_status,
      },
      {
        label: "Receivable Amt",
        // value: allocation?.bank_txn?.Receivable_Amount,
        value: numberFormatter(allocation?.receivable_amt ?? 0),
      },
      {
        label: "Accounting Month",
        value: transaction?.Accounting_Month,
      },
      {
        label: "Aging Bucket",
        value: getAging(formData.age_days),
      },
      {
        label: "Bank Currency",
        value: allocation?.bank_curr
      }
    ],
    [allocation]
  );

  const useIdMap = useMemo(() => listToMap(users, "id", "user_name"), [users]);
  const correctionTypeIdMap = useMemo(
    () => listToMap(allCorrectionTypes, "id", "correction_type"),
    [allCorrectionTypes]
  );

  useEffect(() => {
    if (!isAutoInitiationCorrectionTypes) {
      setShowHistory((!!history.length) || !isAuthorizedUser || viaHistoryLink);
    }
  }, [history?.length]);

  const handleCloseDialog = useCallback((event, reason) => {
    if (isAutoInitiationCorrectionTypes && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }
    if (isAutoInitiationCorrectionTypes) {
      window.location.reload();
    }
    setIsDialogOpen(false);
    handleClose("");
  }, [setIsDialogOpen]);

  const handleSubmitAssing = useCallback(
    async (e) => {
      e.preventDefault();
      const submitResponse = await submit();
      if (submitResponse && ("shouldShowHistory" in submitResponse) && submitResponse.shouldShowHistory) {
        setShowHistory(true);
        setFormData(
          {
            issue_date: getTodaysDateInLocalTimezone(),
            age_days: getAgeDays(
              transaction.Payment_Receive_Date,
              Number(allocation?.unallocated_amt)
            ),
            is_auto_initiated: false,
            comments: "",
          });
        loadHistory();
        setIsAutoInitiationCorrectionTypes(false)
      }
    },
    [setIsDialogOpen, submit]
  );

  const handleInputChange = useCallback(
    (e) => {
      setFormData((data) => ({
        ...data,
        [e.target.name]: e.target.value,
      }));
    },
    [setFormData]
  );

  const handleAddShowHistory = () => {
    if (!isAuthorizedUser && showHistory) {
      toast.error("You are not assigned user!! Please re-assign and then try.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    else {
      setShowHistory(!showHistory);
      setIsAutoInitiationCorrectionTypes(false);
    }
  }

  return (
    <Dialog 
    open={isDialogOpen} 
    onClose={(event, reason) => {
      if (reason === 'backdropClick') {
        return;
      }
      handleCloseDialog();
    }} 
    fullWidth
    >
      <ToastContainer />
      <form onSubmit={handleSubmitAssing}>
        <DialogTitle
          style={{
            background: "#1672DE",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "50px",
            color: "white",
          }}
        >
          <Typography sx={{ fontSize: 20, color: "white" }}> Correction Reasons</Typography>
          <Typography
            sx={{ fontSize: 15, fontWeight: 750, marginLeft: "30px", color: "white" }}
          >
            Policy#: {allocation?.policy_id}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {showHistory && !isAutoInitiationCorrectionTypes ? (
            <History
              setShowHistory={setShowHistory}
              fixedDetails={fixedDetails}
              history={history}
              useIdMap={useIdMap}
              correctionTypeIdMap={correctionTypeIdMap}
            />
          ) : (
            <>
              <Grid container>
                {fixedDetails.map(({ label, value }, i) => (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    key={label}
                    paddingLeft={i % 2 ? 2 : 0}
                    paddingRight={i % 2 ? 0 : 2}
                    marginBottom={2}
                  >
                    <span>{label} </span>
                    <span style={{ fontWeight: "bold" }}>: {value}</span>
                  </Grid>
                ))}
              </Grid>

              <Grid container>
                <Grid item md={6} paddingRight={2}>
                  <p style={{ fontSize: 13, color: "#17191B" }}>Category</p>
                  <Select
                    style={{ ...selectStyleObj }}
                    name="issue_category"
                    onChange={handleInputChange}
                    value={formData.issue_category}
                    required={true}
                  >
                    <MenuItem value="Refund">Refund</MenuItem>
                    <MenuItem value="Internal Transfer">Internal Transfer</MenuItem>
                    <MenuItem value="Broker Invoice">Broker Invoice</MenuItem>
                    <MenuItem value="Premium Payment">
                      Premium Payment
                    </MenuItem>
                    <MenuItem value="Returned Premium">
                      Returned Premium
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item md={6} paddingLeft={2}>
                  <p style={{ fontSize: 13, color: "#17191B" }}>
                    Correction Reason
                  </p>

                  <Select
                    style={{ ...selectStyleObj }}
                    name="correction_type"
                    onChange={handleInputChange}
                    value={formData.correction_type}
                    required={true}
                  >
                    {correctionTypes.map((correction) => (
                      <MenuItem key={correction.id} value={correction.id}>
                        {correction.correction_type}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item md={6} paddingRight={2}>
                  <p style={{ fontSize: 13, color: "#17191B" }}>Assignment</p>

                  <Select
                    style={{ ...selectStyleObj }}
                    name="assignment"
                    onChange={handleInputChange}
                    value={formData.assignment}
                    placeholder="Write details here"
                    required={true}
                  >
                    <MenuItem value="Corrections">Correction</MenuItem>
                    <MenuItem value="GXB">GXB</MenuItem>
                    <MenuItem value="XFI">XFI</MenuItem>
                  </Select>
                </Grid>
                <Grid item md={6} paddingLeft={2}>
                  <p style={{ fontSize: 13, color: "#17191B" }}>
                    Assignment Owner
                  </p>

                  <Select
                    style={{ ...selectStyleObj }}
                    name="issue_owner"
                    onChange={handleInputChange}
                    value={formData.issue_owner}
                    placeholder="Write details here"
                    required={true}
                  >
                    {users.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.user_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item md={12}>
                  <p style={{ fontSize: 13, color: "#17191B" }}>Comment</p>

                  <TextareaAutosize
                    style={{
                      height: 50,
                      width: "100%",
                    }}
                    name="comments"
                    value={formData.comments}
                    onChange={handleInputChange}
                    placeholder="Write details here"
                    required={true}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "flex-end", padding: "15px 25px" }}
        >
          { !viaHistoryLink &&
          <Button
            onClick={() => handleAddShowHistory()}
            sx={{ 
              borderRadius: 100,
              backgroundColor: showHistory ? "#1672DE !important" : "transparent !important",
              color: showHistory ? "white !important" : "#1672DE !important",
              border: showHistory ? "none" : "1px solid #1672DE !important",
              textTransform: "none",
              "&:hover": {
                backgroundColor: showHistory ? "#1565c0 !important" : "rgba(22, 114, 222, 0.08) !important",
                color: showHistory ? "white !important" : "#1565c0 !important",
                border: showHistory ? "none" : "1px solid #1565c0 !important",
              }
            }}
            disabled={isAutoInitiationCorrectionTypes}
          >
            {showHistory ? "Add" : "History"}
          </Button>
          }
          <Button
            onClick={handleCloseDialog}
            sx={{ 
              borderRadius: 100,
              color: "#1672DE !important",
              border: "1px solid #1672DE !important",
              backgroundColor: "transparent !important",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(22, 114, 222, 0.08) !important",
                border: "1px solid #1565c0 !important",
                color: "#1565c0 !important",
              }
            }}
            disabled={isAutoInitiationCorrectionTypes}
          >
            Close
          </Button>
          {!showHistory && (
            <Button
              sx={{ 
                borderRadius: 100,
                backgroundColor: "#1672DE !important",
                color: "white !important",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#1565c0 !important",
                }
              }}
              type="submit"
              disabled={isApiInProgress}
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CorrectionTypes;
